export enum MfaGracePeriodUnit {
    ONCE_PER_DEVICE = 'ONCE_PER_DEVICE',
    HOURS = 'HOURS',
    DAYS = 'DAYS'
}
